import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/comment/page', data, {
    trim: true
  })
}

export function updateById (data) {
  return request.post('/business/comment/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/comment/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/comment/delete/batch', {
    params: {
      ids
    }
  })
}
